/**
 * @module FieldControls
 */
import { createStyles, FormControl, FormHelperText, Grid, makeStyles, Switch as MuiSwitch, Typography, withStyles } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import clsx from 'clsx';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
export const Switch = withStyles(theme => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'inline-flex'
  },
  sizeSmall: {
    width: 20,
    height: 10,
    '& $thumb': {
      width: 8,
      height: 8
    },
    '& $switchBase': {
      padding: 1,
      '&$checked': {
        transform: 'translateX(10px)'
      }
    }
  },
  switchBase: {
    padding: 2,
    color: theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
    opacity: 1,
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    }
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none'
  },
  track: {
    opacity: 1,
    backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[200]
  },
  checked: {},
  disabled: {
    '&$checked': {
      color: theme.palette.grey[500],
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.grey[200],
        borderColor: theme.palette.grey[700]
      }
    }
  }
}))(MuiSwitch);
const useStyles = makeStyles(() => createStyles({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  alignedCenter: {
    alignItems: 'flex-start'
  }
}));
/**
 * Field control that represents a Switcher field.
 */
export const Switcher = props => {
  var _props$localization, _changeTemplatedValue, _props$repository, _props$repository2, _props$repository3, _props$repository4;
  const localization = deepMerge(defaultLocalization.switcher, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.switcher);
  const initialState = props.fieldValue == null && props.actionName === 'new' ? ((_changeTemplatedValue = changeTemplatedValue(props.settings.DefaultValue)) === null || _changeTemplatedValue === void 0 ? void 0 : _changeTemplatedValue.toLowerCase()) === 'true' : !!props.fieldValue;
  const [value, setValue] = useState(initialState);
  const classes = useStyles();
  const handleChange = () => {
    var _props$fieldOnChange;
    setValue(!value);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, !value);
  };
  switch (props.actionName) {
    case 'new':
    case 'edit':
      return /*#__PURE__*/React.createElement(FormControl, {
        className: clsx(classes.root, {
          [classes.alignedCenter]: ((_props$repository = props.repository) === null || _props$repository === void 0 ? void 0 : _props$repository.schemas.isContentFromType(props.content, 'User')) || ((_props$repository2 = props.repository) === null || _props$repository2 === void 0 ? void 0 : _props$repository2.schemas.isContentFromType(props.content, 'WebHookSubscription')) || props.actionName === 'new'
        }),
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly
      }, /*#__PURE__*/React.createElement(Typography, {
        component: "div"
      }, /*#__PURE__*/React.createElement(Grid, {
        component: "label",
        container: true,
        alignItems: "center",
        spacing: 1
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        style: {
          paddingRight: '30px'
        }
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Switch, {
        "data-test": "edit-switch",
        size: "small",
        checked: value,
        onChange: handleChange
      })))), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));
    case 'browse':
    default:
      return /*#__PURE__*/React.createElement(Grid, {
        component: Typography,
        container: true,
        alignItems: "center",
        spacing: 1,
        className: clsx(classes.root, {
          [classes.alignedCenter]: ((_props$repository3 = props.repository) === null || _props$repository3 === void 0 ? void 0 : _props$repository3.schemas.isContentFromType(props.content, 'User')) || ((_props$repository4 = props.repository) === null || _props$repository4 === void 0 ? void 0 : _props$repository4.schemas.isContentFromType(props.content, 'WebHookSubscription'))
        })
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        style: {
          paddingRight: '30px'
        }
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, props.fieldValue != null ? /*#__PURE__*/React.createElement(Switch, {
        size: "small",
        checked: value,
        style: {
          cursor: 'default',
          pointerEvents: 'none'
        }
      }) : localization.noValue));
  }
};
//# sourceMappingURL=switcher.js.map